import React, { useEffect, useState } from "react";
import IncidentCard from "../components/IncidentCard";
import { fetchIncidents } from "../lib/api";
import { classifyType } from "../lib/incidents";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { useCounty } from "../lib/CountyContext";

export default function IncidentList() {
  const { county, current } = useCounty();
  const [incidents, setIncidents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [typeFilter, setTypeFilter] = useState("ALL");

  useEffect(() => {
    setLoading(true);
    fetchIncidents({ days: 90, county })
      .then(setIncidents)
      .finally(() => setLoading(false));
  }, [county]);

  const filtered = incidents.filter((i) => {
    if (typeFilter !== "ALL" && classifyType(i.type) !== typeFilter) return false;
    if (query) {
      const q = query.toLowerCase();
      const hay = `${i.name} ${i.location || ""} ${i.inc_num || ""}`.toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  });

  return (
    <div data-testid="incident-list-page" className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
      <div className="mb-5">
        <div className="text-[15px] uppercase tracking-[0.18em] font-bold text-tac-faint mb-2">
          {current?.name} County · 90-Day Archive
        </div>
        <h1 className="font-display font-black text-3xl tracking-tight text-tac-text mb-4">
          All Incidents
        </h1>

        <div className="flex gap-2 flex-wrap items-center">
          <div className="relative flex-1 min-w-[220px]">
            <MagnifyingGlass size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-tac-faint" />
            <input
              data-testid="list-search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search by name, location, # ..."
              className="w-full bg-tac-surface border border-tac-border focus:border-tac-primary rounded-sm pl-8 pr-3 py-2 text-[15px] text-tac-text placeholder:text-tac-faint outline-none"
            />
          </div>
          {["ALL", "WILDFIRE", "PRESCRIBED", "SMOKE", "OTHER"].map((t) => (
            <button
              key={t}
              data-testid={`list-type-${t.toLowerCase()}`}
              onClick={() => setTypeFilter(t)}
              className={`px-2.5 py-2 text-[10px] font-bold uppercase tracking-wider rounded-sm border ${
                typeFilter === t
                  ? "bg-tac-primary text-white border-tac-primary"
                  : "bg-tac-surface text-tac-dim border-tac-border hover:text-tac-text"
              }`}
            >
              {t === "ALL" ? "All" : t === "WILDFIRE" ? "Fires" : t === "PRESCRIBED" ? "Rx" : t === "SMOKE" ? "Smoke" : "Other"}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <>
          <div className="scan-line" />
          <div className="text-center py-12 text-[15px] text-tac-dim font-mono-tac uppercase tracking-widest">Loading…</div>
        </>
      ) : filtered.length === 0 ? (
        <div className="text-center py-16 text-[15px] text-tac-faint">
          No incidents in {current?.name} County match.
        </div>
      ) : (
        <div className="border border-tac-border bg-tac-surface/30">
          {filtered.map((inc) => (
            <IncidentCard key={inc.id} incident={inc} />
          ))}
        </div>
      )}
    </div>
  );
}
